import { render, staticRenderFns } from "./Enrollments.vue?vue&type=template&id=071f4844&scoped=true"
import script from "./Enrollments.vue?vue&type=script&lang=js"
export * from "./Enrollments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f4844",
  null
  
)

export default component.exports